import { CustomFieldEntityEnum, IBillGroupResp } from '@monetize/types/app';
import { ROUTES } from '../../../constants';
import { BILL_GROUP_STATUS_DISPLAY } from '../../../constants/billGroups';
import { ACCOUNTS_READ_ROLES } from '../../../services/acl/roles';
import { CustomFieldDataForm } from '../../CustomFields/CustomFieldDataForm';
import { LookupTriggerContent } from './LookupTriggerContent';
import { RecordLookupPopover } from './RecordLookupPopover';
import { RecordLookupPopoverHeader } from './RecordLookupPopoverHeader';

export interface BillGroupLookupPopoverProps {
  value: string;
  displayLabel?: string;
}

export function BillGroupLookupPopover({
  value,
  displayLabel,
}: BillGroupLookupPopoverProps) {
  if (!value) {
    return null;
  }
  return (
    <RecordLookupPopover
      recordId={value}
      endpoint={`/api/billGroups/${value}`}
      buttonProps={{ lineClamp: 3 }}
      renderRecord={(record) => {
        const billGroup = record as IBillGroupResp;
        return (
          <>
            <RecordLookupPopoverHeader
              recordId={billGroup.id}
              href={ROUTES.getBillGroupPageRoute(billGroup.id)}
              recordName={billGroup.name}
              displayStatus={BILL_GROUP_STATUS_DISPLAY[billGroup.status]}
              roles={ACCOUNTS_READ_ROLES}
            />

            <CustomFieldDataForm
              entity={CustomFieldEntityEnum.BILL_GROUP}
              value={billGroup.customFields}
              isReadOnly
              variant="readonly"
              setValue={() => {}}
              fieldColSpan={6}
              mode="modal"
            />
          </>
        );
      }}
    >
      <LookupTriggerContent displayLabel={displayLabel} value={value} />
    </RecordLookupPopover>
  );
}
